module.exports = __webpack_public_path__ + "static/fonts/alimama.98a341c.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/alimama.ttf
// module id = O4li
// module chunks = 46